import React, { useState, useEffect } from "react";
import ModelA from "../assets/ModelA.png";
import SFS1 from "../assets/ClearSpan.jpg";
import SFS2 from "../assets/CurvedRafter.jpg";
import SFS3 from "../assets/Multi-Gable.jpg";
import SFS4 from "../assets/multispan-1.jpg";
import SFS5 from "../assets//multispan-1.jpg";
import SFS6 from "../assets/RoofSystemFixedJoint.jpg";
import SFS7 from "../assets/RoofSystemReleasedJoint.jpg";
import SFS8 from "../assets/SingleSlope.jpg";
import SSS1 from "../assets/JackBeam.jpg";
import SSS2 from "../assets/WalkWay.jpg";
import SSS3 from "../assets/sky-bridge.jpg";
import SSS4 from "../assets/bracing.jpg";
import SSS5 from "../assets/canopy-3-small.jpg";
import SSS6 from "../assets/cat-ladder.jpg";
import SSS7 from "../assets/checker-plate.jpg";
import SSS8 from "../assets/composite-metal-decking-1-small.jpg";
import SSS9 from "../assets/handrail.jpg";
import SSS10 from "../assets/linkway.jpg";
import SSS11 from "../assets/monitor.jpg";
import SSS12 from "../assets/partition.jpg";
import SSS13 from "../assets/purlin-bracing.jpg";
import SSS14 from "../assets/OpenWebStruture.jpg";
import SSS15 from "../assets/HybridStruture.jpg";
import SSS16 from "../assets/LaceColumn.jpg";
import RW1 from "../assets/01-klip-dim.jpg";
import RW2 from "../assets/02-seam-dim.png";
import RW3 from "../assets/03-ton-cach-nhiet.jpg";
import RW4 from "../assets/04-5-song-dim.jpg";
import RW5 from "../assets/05-6-song-dim.jpg";
import RW6 from "../assets/06-7-song-dim.jpg";
import RW7 from "../assets/07-9-song-dim.jpg";
import RW8 from "../assets/08-ton-tran-dim.jpg";
import ACC1 from "../assets/LOUVER.jpg";
import ACC2 from "../assets/STAIR(2).jpg";
import ACC3 from "../assets/HANDRAIL(2).jpg";
import ACC4 from "../assets/DOORS.jpg";
import ACC5 from "../assets/GRATING.jpg";
import ACC6 from "../assets/CHECKERED.jpg";
import ACC7 from "../assets/BIRDNET.jpg";
import ACC8 from "../assets/SKYLIGHT.jpg";
import ACC9 from "../assets/DRAINAGESYSTEM.jpg";
import ACC10 from "../assets/INSULATIONS.jpg";
import ACC11 from "../assets/FLASHING.jpg";



// Styles
const titletext = {   
  color: "#13499C",
  fontSize: "30px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "normal",
  textTransform: "uppercase",
textAlign: "center",
};

const navTabs01Style = {
  width: "100%",
  background: "#f7f9fb",
  padding: "4px 0 12px 0",
  display: "flex",
  justifyContent: "center",
};

const navTabsStyle = {
  display: "flex",
  gap: "0px",
  borderBottom: "2px solid #e0e0e0",
  width: "100%",
  maxWidth: "1000px",
  justifyContent: "center",
};

const navLinkStyle = {
  fontSize: "0.95rem",
  fontWeight: 600,
  color: "#13499C",
  background: "none",
  border: "1px solid #939597",
  borderRadius: 0,
  padding: "12px 24px",
  textTransform: "uppercase",  
  transition: "color 0.2s, borderBottom 0.2s, background 0.2s",
  position: "relative",
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
};

const navLinkActiveStyle = {
  ...navLinkStyle,
  color: "#fff",
  borderBottom: "3px solid #13499C",
  background: "#939597",
};

const navLinkHoverStyle = {
  ...navLinkStyle,
  color: "#fff",
  background: "#939597",
};

const cardGridStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "24px",
  justifyContent: "center",
  marginTop: "24px",
};
const arrowStyle = {
    fontSize: "2rem",
    color: "#13499C",
    background: "none",
    border: "none",
    cursor: "pointer",
    margin: "0 16px",
    userSelect: "none",
    outline: "none"
  };
const cardStyle = {
  width: "1020px",
  height: "100%",
  background: "#fff",
 
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  overflow: "hidden",
  textAlign: "center",
  transition: "box-shadow 0.2s",
};

const cardImgStyle = {
    width: "100%",         // Image fills the card's width
    // Increased fixed height for a bigger image
    objectFit: "cover",    // Ensures the image covers the area, cropping if needed[1][2][6][7]
    display: "block",
  };

const cardTitleStyle = {
  fontWeight: 600,
  fontSize: "1rem",
  color: "#13499C",
  padding: "12px",
};

// Tab and card data
const tabs = [
  { label: "MODEL" },
  { label: "STANDARD FRAMING SYSTEMS" },
  { label: "SUB - STRUCTURAL SYSTEMS" },
  { label: "ROOF, WALL" },
  { label: "ACCESSORIES" },
];

const tabCards = [
  // MODEL
  [
    { title: "", img: ModelA },  
  ],
  // STANDARD FRAMING SYSTEMS
  [
    { title: " ", img: SFS1 },
    { title: " ", img: SFS2 },
    { title: " ", img: SFS3 },
    { title: " ", img: SFS4 },
    { title: " ", img: SFS5 },
    { title: " ", img: SFS6 },
    { title: " ", img: SFS7 },
    { title: " ", img: SFS8 },    
  ],
  // SUB - STRUCTURAL SYSTEMS
  [
    { title: "JACK BEAM", img: SSS1 },
    { title: "WALK WAY", img: SSS2 },
    { title: "SKY BRIDGE", img: SSS3 },
    { title: "BRACING", img: SSS4 },
    { title: "CANOPY", img: SSS5 },
    { title: "CAT LADER", img: SSS6 },
    { title: "CHECK PLATE", img: SSS7 },
    { title: "COMPOSITE METAL DECKING", img: SSS8 },
    { title: "HANDRAIL", img: SSS9 },
    { title: "LINKWAY", img: SSS10 },
    { title: "MONITOR", img: SSS11 },
    { title: "PARTION", img: SSS12 },
    { title: "PURLIN BRACING", img: SSS13 },
    { title: "OPENWEBSTRUCTURE", img: SSS14 },
    { title: "HYBRID STRUTURE", img: SSS15 },
    { title: "LACE COLUMN", img: SSS16 },
    
  ],
  // ROOF, WALL
  [
    { title: "KLIPLOCK 940MM", img: RW1 },
    { title: "SEAMLOCK 475MM", img: RW2 },
    { title: "INSULATION PANELS", img: RW3 },
    { title: "5-WAVE ROOFING", img: RW4 },
    { title: "6-WAVE ROOFING", img: RW5 },
    { title: "7-WAVE ROOFING", img: RW6 },
    { title: "9-WAVE ROOFING", img: RW7 },
    { title: "TON TRAN", img: RW8 },
   
  ],
  // ACCESSORIES
  [
    { title: "LOUVER", img: ACC1 },
    { title: "STAIR", img: ACC2 },
    { title: "HANDRAIL", img: ACC3 },
    { title: "DOORS", img: ACC4 },
    { title: "GRATING", img: ACC5 },
    { title: "CHECKERED", img: ACC6 },
    { title: "BIRD NET", img: ACC7 },
    { title: "SKYLIGHT", img: ACC8 },
    { title: "DRAINAGE SYSTEM", img: ACC9 },
    { title: "INSULATIONS", img: ACC10 },
    { title: "FLASHING", img: ACC11 },

  ],
];
function Products() {
    const [activeIdx, setActiveIdx] = useState(0);
    const [slideIdx, setSlideIdx] = useState(0);
  
    const cards = tabCards[activeIdx];
  
    useEffect(() => {
      setSlideIdx(0);
    }, [activeIdx]);
  const [hoverIdx, setHoverIdx] = useState(null);

  return (
    <div>
      <h2
        className="line-bottom product-main-title mb-5 text-uppercase"
        style={titletext}
      >
        PRE - ENGINEERED STEEL BUILDING
      </h2>
      <div style={navTabs01Style}>
        <nav>
          <div style={navTabsStyle}>
            {tabs.map((tab, idx) => (
              <div
                key={tab.label}
                role="tab"
                aria-selected={activeIdx === idx}
                style={
                  activeIdx === idx
                    ? navLinkActiveStyle
                    : hoverIdx === idx
                    ? navLinkHoverStyle
                    : navLinkStyle
                }
                onClick={() => setActiveIdx(idx)}
                onMouseEnter={() => setHoverIdx(idx)}
                onMouseLeave={() => setHoverIdx(null)}
                tabIndex={0}
                onKeyPress={e => { if (e.key === "Enter") setActiveIdx(idx); }}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </nav>
      </div>
      {/* Cards for the active tab */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 32 }}>
  <button
    style={arrowStyle}
    onClick={() => setSlideIdx(idx => Math.max(0, idx - 1))}
    disabled={slideIdx === 0}
    aria-label="Previous"
  >
    &#8592;
  </button>
  <div style={cardStyle}>
    <img src={cards[slideIdx].img} alt={cards[slideIdx].title} style={cardImgStyle} />
    <div style={cardTitleStyle}>{cards[slideIdx].title}</div>
  </div>
  <button
    style={arrowStyle}
    onClick={() => setSlideIdx(idx => Math.min(cards.length - 1, idx + 1))}
    disabled={slideIdx === cards.length - 1}
    aria-label="Next"
  >
    &#8594;
  </button>
</div>

{/* Thumbnails */}
<div style={{ display: "flex", justifyContent: "center", marginTop: 16, gap: 8 }}>
  {cards.map((card, idx) => (
    <img
      key={idx}
      src={card.img}
      alt={card.title}
      style={{
        width: 60,
        height: 40,
        objectFit: "cover",
        borderRadius: 4,
        border: idx === slideIdx ? "2px solid #13499C" : "2px solid #e0e0e0",
        cursor: "pointer",
        opacity: idx === slideIdx ? 1 : 0.6,
        boxShadow: idx === slideIdx ? "0 0 8px #13499C33" : "none",
        transition: "border 0.2s, opacity 0.2s"
      }}
      onClick={() => setSlideIdx(idx)}
    />
  ))}
</div>

<div style={{ textAlign: "center", marginTop: 12, color: "#13499C" }}>
  {slideIdx + 1} / {cards.length}
</div>
     
    </div>
  );
}

export default Products;
